/**
 * Draw/render a single chart-data AJAX response into its container, based on chart_type.
 * Shared by the initial dashboard render, column sorting, and the dashboard filter bar.
 * @param $chart_container the DOM element (not jQuery-wrapped) the chart/table renders into
 * @param payload the chart's own data-chart attributes (id, chart_type, ...)
 * @param res the AJAX response (google chart data/options, or rendered table HTML)
 * @param decimal_separator
 * @param thousands_separator
 * @param lang
 */
export function renderChartResult($chart_container, payload, res, decimal_separator, thousands_separator, lang) {
    // The report title is shown in the dashboard's chart header, don't draw it again inside the chart.
    if (res && res.options) {
        res = Object.assign({}, res, {options: Object.assign({}, res.options, {title: ''})});
    }

    if (payload.chart_type === 'Bar') {

        google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.ColumnChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    } else if (payload.chart_type === 'Line') {
        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.LineChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    } else if (payload.chart_type === 'Pie') {

        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.PieChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    } else if (payload.chart_type === 'Donut') {

        google.charts.load("current", {packages: ["corechart"], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = Object.assign({}, res.options, {pieHole: 0.4});
            let chart = new google.visualization.PieChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    } else if (payload.chart_type === 'Area') {

        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.AreaChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    } else if (payload.chart_type === 'Scatter') {

        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.ScatterChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    } else if (payload.chart_type === 'Stacked Bar') {

        google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = Object.assign({}, res.options, {
                legend: {position: 'top', maxLines: 3},
                bar: {groupWidth: '75%'},
                isStacked: true,
            });
            let chart = new google.visualization.ColumnChart($chart_container);
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    } else if (payload.chart_type === 'Table' || payload.chart_type === 'SubTable') {
        $($chart_container).html(res);
    }
}

$(document).ready(function (e) {
    if ($('.charts').length) {
        let $charts = $('.chart'),
            decimal_separator = $('.dashboards').attr('data-decimal-separator'),
            thousands_separator = $('.dashboards').attr('data-thousands-separator'),
            lang = $('.dashboards').attr('data-lang');

        $('.grid-stack').gridstack();

        $('.grid-stack').on('gsresizestop', function (event, elem) {
            drawDashboardCharts();
        });

        $('.grid-stack').on('change', function (event, items) {
            updateChartLayoutParams();
        });

        function checkScroll($element) {
            var $scrollArrow = $element.parents('.chart').find('.scroll-arrow');
            var isAtBottom = $element.scrollTop() + $element.innerHeight() >= $element[0].scrollHeight;

            if (isAtBottom) {
                $scrollArrow.hide();
            } else {
                $scrollArrow.show();
            }
        }

        // Request params (sort/criteria) the chart's first page was loaded with, reused for the next pages
        let chartQueries = {};

        function loadNextTablePage($table, payload) {
            let next_page = $table.attr('data-next-page');

            if (!next_page || $table.data('loading')) {
                return;
            }

            $table.data('loading', true);

            $.ajax({
                type: 'GET',
                url: `/chart/${payload.id}`,
                data: Object.assign({}, chartQueries[payload.id], {page: next_page}),
                success: function (res) {
                    let $totals = $table.find('tbody .chart-totals-row');

                    if ($totals.length) {
                        $totals.before(res.rows);
                    } else {
                        $table.find('tbody').append(res.rows);
                    }

                    $table.attr('data-next-page', res.next_page || '');
                    $table.data('loading', false);
                    fillTableViewport($table, payload);
                },
                error: function () {
                    $table.data('loading', false);
                }
            });
        }

        function fillTableViewport($table, payload) {
            // Keep loading while the rows don't overflow the widget, otherwise no scroll event would fire
            if ($table[0].scrollHeight <= $table.innerHeight()) {
                loadNextTablePage($table, payload);
            }
        }

        function bindTableScroll(payload) {
            let $table = $('#chart-' + payload.id).find('.chart-table-responsive');

            if (!$table.length) {
                return;
            }

            $table.on('scroll', function () {
                checkScroll($table);

                if ($table.scrollTop() + $table.innerHeight() >= $table[0].scrollHeight - 200) {
                    loadNextTablePage($table, payload);
                }
            });

            fillTableViewport($table, payload);
        }

        $(document).on('mouseenter', '.chart-table-responsive', function() {
            var $scrollArrow = $(this).parents('.chart').find('.scroll-arrow');
            var isAtBottom = $(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight;

            if (!isAtBottom) {
                $scrollArrow.show();
            }
        });

        $(document).on('mouseleave', '.chart-table-responsive', function() {
            var $scrollArrow = $(this).parents('.chart').find('.scroll-arrow');
            $scrollArrow.hide();
        });

        $(document).on('click', '.sort-chart-column', function (e) {
            e.preventDefault();
            let field = $(this).attr('data-column'),
                $order = $(this).find('.btn_active'),
                order = $order.hasClass('fa-sort-up') ? 'desc' : 'asc',
                $chart = $(this).parents('.chart'),
                payload = JSON.parse($($chart).attr('data-chart')),
                data = Object.assign({}, chartQueries[payload.id], {
                    sort: order,
                    field,
                    render: 'chart'
                });

            chartQueries[payload.id] = data;

            $.ajax({
                type: "GET",
                url: `/chart/${payload.id}`,
                data,
                success: function (res) {
                    let $chart_container = $('#chart-' + payload.id)[0];

                    renderChartResult($chart_container, payload, res, decimal_separator, thousands_separator, lang);
                    bindTableScroll(payload);
                }
            });
        });

        drawDashboardCharts();

        function drawDashboardCharts() {
            $($charts).each(function (i, $chart) {
                let payload = JSON.parse($($chart).attr('data-chart'));

                chartQueries[payload.id] = {render: 'chart'};

                $.ajax({
                    type: "GET",
                    url: `/chart/${payload.id}`,
                    data : chartQueries[payload.id],
                    success: function (res) {
                        let $chart_container = $('#chart-' + payload.id)[0];

                        renderChartResult($chart_container, payload, res, decimal_separator, thousands_separator, lang);

                        if (payload.chart_type === 'Table' || payload.chart_type === 'SubTable') {
                            bindTableScroll(payload);
                        }
                    }
                });
            });
        }

        // Expose for the dashboard filter bar (dashboard_chart_filters.js) so it can
        // re-run the same chart-data fetch + render after applying/clearing ad-hoc criteria.
        window.redrawDashboardChart = function (chart_id, criteria) {
            let $chart = $charts.filter(function (i, el) {
                return JSON.parse($(el).attr('data-chart')).id == chart_id;
            });

            if (!$chart.length) {
                return;
            }

            let payload = JSON.parse($chart.attr('data-chart'));
            let data = {render: 'chart'};

            if (criteria) {
                data.criteria = JSON.stringify(criteria);
            }

            chartQueries[payload.id] = data;

            $.ajax({
                type: 'GET',
                url: `/chart/${payload.id}`,
                data,
                success: function (res) {
                    let $chart_container = $('#chart-' + payload.id)[0];

                    renderChartResult($chart_container, payload, res, decimal_separator, thousands_separator, lang);

                    if (payload.chart_type === 'Table' || payload.chart_type === 'SubTable') {
                        bindTableScroll(payload);
                    }
                }
            });
        };

        function updateChartLayoutParams() {
            let payload = [];

            let nodes = $('.grid-stack').data('gridstack').grid.nodes;
            $(nodes).each(function (i, item) {
                payload.push({
                    gs_x: item.x,
                    gs_y: item.y,
                    gs_width: item.width,
                    gs_height: item.height,
                    id: $(item.el).attr('data-chart-id')
                })
            });

            $.ajax({
                type: 'POST',
                url: '/dashboard/layout',
                data: {
                    charts: payload
                },
                success: function (res) {
                    console.log(res);
                }
            });
        }
    }
});